import ajaxService from '../services/ajaxService';

export default function filterWidget() {
    function resetSelects(selects, backup) {
        selects.forEach((element, index) => {
            const select = element;
            select.innerHTML = backup[index];
        });
    }

    function createBackup(selects) {
        const backup = [];
        selects.forEach((select) => {
            let optionsHTML = '';
            select.options.forEach((option) => {
                optionsHTML += `<option value="${option.value}">${option.innerHTML}</option>`;
            });
            backup.push(optionsHTML);
        });

        return backup;
    }

    const filters = document.querySelectorAll('.js-filter-widget');
    filters.forEach((filter) => {
        const selects = filter.querySelectorAll('.js-filter-widget-field select');
        const selectsBackup = createBackup(selects);
        const {term} = filter.dataset;

        let selectedValues = [];

        const resetTrigger = filter.querySelector('.js-filter-widget-reset');
        resetTrigger.addEventListener('click', (event) => {
            event.preventDefault();
            const url = window.location.href.split('?')[0];
            window.location = `${url}#filtered`;
        });

        selects.forEach((select) => {
            select.addEventListener('change', () => {
                selectedValues.push(select.value);

                selects.forEach((element) => {
                    const newSelect = element;
                    if (select.name !== newSelect.name) {
                        if (select.value === '') {
                            resetSelects(selects, selectsBackup);
                            selectedValues = [];
                        } else {
                            const {dependsOnParent} = newSelect.dataset;
                            const url = `${window.location.protocol}//${window.location.hostname}`
                                + `/wp-json/wp-tax-relations/v1.0/relations?term=${term}`
                                + `&taxonomy=${newSelect.name}&rel_taxonomy=${select.name}&rel_term=${select.value}`
                                + `&children=${dependsOnParent}`;

                            newSelect.disabled = true;
                            ajaxService.get(url).then((resolve) => {
                                const jsonData = resolve;
                                newSelect.innerHTML = `<option value="">${newSelect.dataset.label}</option>`;
                                if (jsonData !== false) {
                                    let selectedIndex;
                                    let selectedValue;
                                    jsonData.forEach((entry, index) => {
                                        const value = entry.slug;
                                        const label = entry.name;
                                        newSelect.innerHTML += `<option value="${value}">${label}</option>`;

                                        if (selectedValues.includes(value)) {
                                            selectedIndex = index + 1;
                                            selectedValue = value;
                                        }
                                    });

                                    if (selectedValue && selectedIndex) {
                                        newSelect.selectedIndex = selectedIndex;
                                        newSelect.value = selectedValue;
                                    }
                                }
                                newSelect.disabled = false;
                            }, () => {});
                        }
                    }
                });
            });
        });
    });
}
